export const ItemsData = [
    {
        id: "1",
        name: "Naga Chicken Burger",
        img: "https://elanta.app/nazar/starbelly-demo/img/menu/3.jpg",
        category: "Main Dishes",
        badge: "Non Veg",
        desc: "A burger is a flat round mass of minced meat or vegetables, which is fried and often eaten in a bread roll.",
        rating: {
            "total_rating": 45,
            "total_people": 12
        },
        price: 250
    }, 
    {
        id: "2",
        name: "Vegetable Starter",
        img: "https://elanta.app/nazar/starbelly-demo/img/menu/1.jpg",
        category: "Starters",
        badge: "Vegan",
        desc: "Fresh corn is considered a starchy vegetable. Its nutrient content differs from dry corn, and it is eaten in different ways",
        rating: {
            "total_rating": 32,
            "total_people": 8
        },
        price: 170
    },
    {
        id: "3",
        name: "Vegetable Salad",
        img: "https://elanta.app/nazar/starbelly-demo/img/menu/2.jpg",
        category: "Main Dishes",
        badge: "Hot",
        desc: "A salad is a dish consisting of mixed, mostly natural ingredients with at least one raw ingredient.",
        rating: {
            "total_rating": 45,
            "total_people": 12
        },
        price: 230
    },
    {
        id: "4",
        name: "Chicken Pasta",
        img: "https://elanta.app/nazar/starbelly-demo/img/menu/5.jpg",
        category: "Main Dishes",
        badge: "Non Veg",
        desc: "This chicken pasta recipe is comfort food and dinner in 15 mins. Chicken pieces cooked in a creamy white sauce then tossed in pasta",
        rating: {
            "total_rating": 52,
            "total_people": 13
        },
        price: 150
    },
    {
        id: "5",
        name: "Naga Chicken",
        img: "https://elanta.app/nazar/starbelly-demo/img/menu/9.jpg",
        category: "Fast Food",
        badge: "Hot",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 27,
            "total_people": 6
        },
        price: 120
    },
    {
        id: "6",
        name: "Apple Jelly",
        img: "https://elanta.app/nazar/starbelly-demo/img/menu/10.jpg",
        category: "Drinks",
        badge: "Drinks",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 19,
            "total_people": 21
        },
        price: 90
    },
    {
        id: "7",
        name: "Mixed Foods",
        img: "https://elanta.app/nazar/starbelly-demo/img/menu/11.jpg",
        category: "Desserts",
        badge: "vegan",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 22,
            "total_people": 6
        },
        price: 210
    },   
    {
        id: "8",
        name: "Dragan Juice",
        img: "https://elanta.app/nazar/starbelly-demo/img/menu/6.jpg",
        category: "Drinks",
        badge: "drinks",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 25,
            "total_people": 7
        },
        price: 70
    },    
    {
        id: "9",
        name: "Lemon Juice",
        img: "https://www.kindpng.com/picc/m/41-410516_juice-png-clipart-juice-png-transparent-png.png",
        category: "Drinks",
        badge: "drinks",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 44,
            "total_people": 9
        },
        price: 50
    },
    {
        id: "10",
        name: "Mango Juice",
        img: "https://5.imimg.com/data5/TQ/GY/MY-46593638/fresh-mango-juice-250x250.jpg",
        category: "Drinks",
        badge: "drinks",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 29,
            "total_people": 8
        },
        price: 60
    },    
    {
        id: "11",
        name: "Grilled Chicken With Plain Rice",
        img: "https://www.anajichoicemart.com/wp-content/uploads/2021/12/Grilled-chicken-with-plain-rice-1.jpg",
        category: "Starters",
        badge: "Non Veg",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 202,
            "total_people": 42
        },
        price: 520
    },
    {
        id: "12",
        name: "Grilled Chicken With Fried Rice",
        img: "https://www.anajichoicemart.com/wp-content/uploads/2021/12/grilled-chicken-with-fried-rice-1-e1640012448308.png",
        category: "Starters",
        badge: "Non Veg",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 149,
            "total_people": 30
        },
        price: 570
    },
    {
        id: "13",
        name: "Grilled Chicken With Jollof Rice",
        img: "https://www.anajichoicemart.com/wp-content/uploads/2021/12/grilled-chicken-with-jollof-e1639858541585.jpeg",
        category: "Starters",
        badge: "Non Veg",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 146,
            "total_people": 30
        },
        price: 530
    },
    {
        id: "14",
        name: "Chicken Kiev",
        img: "https://www.anajichoicemart.com/wp-content/uploads/2021/06/Chicken-Kiev.webp",
        category: "Fast Food",
        badge: "Non Veg",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 41,
            "total_people": 13
        },
        price: 60
    },    
    {
        id: "15",
        name: "Cajun Chicken",
        img: "https://www.anajichoicemart.com/wp-content/uploads/2021/06/Cajun-chicken.jpg",
        category: "Fast Food",
        badge: "Non Veg",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 57,
            "total_people": 13
        },
        price: 85
    },    
    {
        id: "16",
        name: "Stir-Fry Chicken",
        img: "https://www.anajichoicemart.com/wp-content/uploads/2021/06/chicken-stir-fry.jpeg",
        category: "Fast Food",
        badge: "Non Veg",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 20,
            "total_people": 13
        },
        price: 140
    },    
    {
        id: "17",
        name: "Ice-Cream Cake",
        img: "https://www.anajichoicemart.com/wp-content/uploads/2022/02/WhatsApp-Image-2022-02-21-at-1.05.09-PM-200.jpeg",
        category: "Desserts",
        badge: "desserts",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 340,
            "total_people": 70
        },
        price: 420
    },
    {
        id: "18",
        name: "Khumalo",
        img: "https://www.anajichoicemart.com/wp-content/uploads/2021/12/acm-khumalo.jpg",
        category: "Desserts",
        badge: "desserts",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 96,
            "total_people": 27
        },
        price: 100
    },
    {
        id: "19",
        name: "Waffle With Vanilla Ice-Cream",
        img: "https://www.anajichoicemart.com/wp-content/uploads/2021/12/Waffles-and-Ice-cream.jpg",
        category: "Desserts",
        badge: "desserts",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 71,
            "total_people": 29
        },
        price: 60
    },
    {
        id: "20",
        name: "PanCake With Vanilla Ice-Cream",
        img: "https://www.anajichoicemart.com/wp-content/uploads/2021/06/pancake-with-vanilla-ice-cream.jpg",
        category: "Desserts",
        badge: "desserts",
        desc: "Naga curry is a chicken, beef, lamb, fish, prawns, or choice of protein, cooked in aromatic spicy curry sauce.",
        rating: {
            "total_rating": 62,
            "total_people": 11
        },
        price: 70
    },
]